import { createReducer, on } from '@ngrx/store';
import * as CurrencyActions from '../actions/currency.actions';

export const initialState: string[] = [];
export const CurrencyReducer = createReducer(
  initialState,
  on(CurrencyActions.setCurrencyList, (state, { currencyList }) => [
    ...currencyList,
  ]),
);
